import { render, staticRenderFns } from "./templateSingleOptionWithimg.vue?vue&type=template&id=25723a42&scoped=true"
import script from "./templateSingleOptionWithimg.vue?vue&type=script&lang=js"
export * from "./templateSingleOptionWithimg.vue?vue&type=script&lang=js"
import style0 from "./templateSingleOptionWithimg.vue?vue&type=style&index=0&id=25723a42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25723a42",
  null
  
)

export default component.exports